var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-flex',{staticClass:"title pl-4",staticStyle:{"height":"80px"},attrs:{"layout":"","align-center":""}},[_vm._v("违章提交列表")]),_c('l-data-card',{staticClass:"px-2",attrs:{"headers":_vm.headers,"get-data":_vm.getItems,"clickable":""},on:{"click:row":function($event){return _vm.goDetails($event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }